import type { PackagingPlanRow } from "./packaging-report-types.js";

export type PackagingDayPlanRow = {
  plan: PackagingPlanRow;
  allocations: Array<{ sourceRow: number; sourceCell: string; quantity: number }>;
};

/** Carry display fragments of at most one case to the next larger allocation of the same Excel row. */
export function displayPlanAllocations(row: PackagingPlanRow) {
  const sorted = [...row.allocations].sort((a, b) => a.date.localeCompare(b.date));
  return sorted.map((allocation, index) => {
    const next = sorted.slice(index + 1).find((candidate) => candidate.date > allocation.date
      && candidate.quantity >= 1 && candidate.quantity > allocation.quantity);
    return allocation.quantity > 0 && allocation.quantity <= 1 && next
      ? { ...allocation, date: next.date, sourceDate: allocation.date }
      : { ...allocation, sourceDate: allocation.date };
  });
}

export function listPlanRowsForDay(rows: PackagingPlanRow[], date: string): PackagingDayPlanRow[] {
  return rows.flatMap((plan) => {
    const dayAllocations = displayPlanAllocations(plan).filter((item) => item.date === date);
    if (!dayAllocations.length) return [];
    return [{ plan, allocations: dayAllocations.map((allocation) => ({ sourceRow: plan.sourceRow,
      sourceCell: allocation.sourceCell, quantity: allocation.quantity })) }];
  });
}
